import GuestList from '../guest-list/GuestList.react';

import Pos from '../pos/Pos.react';
import ConfigStore from '../../stores/ConfigStore';
import CartDisplay from '../cart-display/CartDisplay.react';
class Main extends React.Component {


    render() {
        var route       = this.props.route;
        var user        = this.props.user;
        return (
            <div
                id='main'
                className='main'>

                { route[0] === 'guest-list' && user &&
                    <GuestList
                        route={route}
                        user={user}/>
                }

                { route[0] === 'pos' &&
                    <Pos
                        route={route} />
                }
                
                { route[0] === 'cart-display' &&
                    <CartDisplay
                        route={route} />
                }
                <div style={{ fontSize: 10, position: 'absolute', left: 5, bottom: 0}}>
                    {/* <StatusWidget user={user}/> */}
                    Build: {ConfigStore.getBuildNumber()}  </div>
               
            </div>
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./ui_src/app/components/main/Main.react.jsx